import React, { useContext, useEffect, useRef, useState } from 'react';
import './DeliveryTimeSlotPicker.scss';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import { SwipeableDrawer } from '@mui/material';
import AlertDialog from '../../atomic/Dialog/Dialog';
import AtomicButton from '../../atomic/button/AtomicButton';
import Loader from '../Loader/Loader';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';
import DeliveryOptionsNewSlots from './DeliveryOptions';

const DeliveryTimeSlotPicker = (props) => {
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const drawerContainerRef = useRef();
  const [showDisagreeButton, setshowDisagreeButton] = useState(false);
  const [buttonAgreeLabel, setButtonAgreeLabel] = useState('Okay');
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const {
    // productsData = {},
    sortedKitchenData,
    activeButton,
    setActiveButton,
    onClickCheckout,
    fullDeliverySlotObj,
  } = useContext(OnTheMenuDataContext);
  const { setDiscountCodeValidationData, setPromoCodeOrderSummary } =
    useContext(CheckoutDataContext);

  const { delivery_type_available } = sortedKitchenData;

  const DeliveryDriverShortage = () =>
    sortedKitchenData?.delivery_driver_shortage?.driver_shortage &&
    sortedKitchenData?.delivered_by !== 'kitchen';

  useEffect(() => {
    if (DeliveryDriverShortage() || delivery_type_available === 'pickup') {
      setActiveButton('pickup');
    }
  }, [JSON.stringify(sortedKitchenData)]);

  // console.log('---FullDeliverySlotObj', fullDeliverySlotObj);
  // console.log('---SelectedDeliverySlot', selectedDeliverySlot);
  // console.log('---SelectedDate', selectedDate);
  // console.log('----selectedDeliveryOption', selectedDeliveryOption);

  const onAlertAgree = () => {
    onClickCheckout(false); //
    setAlertOpen(false);
  };

  const onAlertDisagree = () => {
    setAlertOpen(false);
  };
  const initfunc = async () => {
    if (isDesktop || isIpad) {
      setAlertOpen(true);
    }

    if (isMobile) {
      setIsDrawerOpen(true);
    }
  };

  const onButtonClickOne = (value) => {
    setActiveButton(value);
    // Removing promo code
    setDiscountCodeValidationData({
      loading: false,
      data: null,
      errorMessage: '',
      success: null,
    });
    setPromoCodeOrderSummary({});
    return;
  };

  const ActiveStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#181436',
    fontSize: '11px',
    // backgroundColor: '#181436',
    backgroundColor: 'white',
    border: '2px solid #181436',
    fontFamily: 'Inter Bold',
    borderRadius: '20px',
    width: '65px',
    height: '25px',
    cursor: 'pointer',
  };

  const InActiveStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px',
    color: '#8B8995',
    border: '1px solid #8B8995',
    fontSize: '11px',
    fontFamily: 'Inter Light',
    letterSpacing: '0.5px',
    border: 'none',
    borderRadius: '20px',
    width: '60px',
    height: '20px',
    cursor: 'pointer',
  };

  const ActiveStyleMobile = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px',
    color: 'white',
    letterSpacing: '0.5px',
    border: '1px solid #181436',
    fontSize: '13px',
    letterSpacing: '0.5px',
    backgroundColor: '#181436',
    border: '1px solid #181436',
    fontFamily: 'Inter Medium',
    borderRadius: '20px',
    height: '20px',
    cursor: 'pointer',
  };

  const InActiveStyleMobile = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: activeButton === 'pickup' ? '5px' : '5px 5px 5px 0px',
    color: '#8B8995',
    border: '1px solid #8B8995',
    fontSize: '13px',
    fontFamily: 'Inter Medium',
    border: 'none',
    borderRadius: '20px',
    height: '20px',
    cursor: 'pointer',
  };

  const OkyToDelivery = () => {
    onClickCheckout(false); //
    setIsDrawerOpen(false);
  };

  // console.log('----delivery_type_available', delivery_type_available);
  // console.log('----sortedKitchenData', sortedKitchenData);
  // We have to keep this
  const DeliveryToggleBtns = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: DeliveryDriverShortage() ? '110px' : '140px',
          borderRadius: '20px',
          height: '30px',
          backgroundColor: '#F8F8F8',
          marginTop: isMobile ? '10px' : '5px',
          marginBottom: isMobile ? '10px' : '5px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {(delivery_type_available === 'both' || delivery_type_available === 'home delivery') &&
            !DeliveryDriverShortage() && (
              <button
                name='delivery'
                onClick={(e) => (onButtonClickOne('delivery'), initfunc())}
                style={activeButton === 'delivery' ? ActiveStyle : InActiveStyle}
              >
                Delivery
              </button>
            )}

          {(delivery_type_available === 'both' || delivery_type_available === 'pickup') && (
            <button
              name='pickup'
              onClick={(e) => (onButtonClickOne('pickup'), initfunc())}
              style={activeButton === 'pickup' ? ActiveStyle : InActiveStyle}
            >
              Pickup
            </button>
          )}
        </div>
      </div>
    );
  };

  if (isMobile) {
    return (
      <>
        <div className='deliveryTimeSlotPicker-button-mobile'>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {(delivery_type_available === 'both' || delivery_type_available === 'home delivery') &&
              !DeliveryDriverShortage() && (
                <button
                  name='delivery'
                  onClick={(e) => (onButtonClickOne('delivery'), initfunc())}
                  style={activeButton === 'delivery' ? ActiveStyleMobile : InActiveStyleMobile}
                >
                  Deli..
                </button>
              )}

            {(delivery_type_available === 'both' || delivery_type_available === 'pickup') && (
              <button
                name='pickup'
                onClick={(e) => (onButtonClickOne('pickup'), initfunc())}
                style={activeButton === 'pickup' ? ActiveStyleMobile : InActiveStyleMobile}
              >
                {DeliveryDriverShortage() ? 'Pickup' : 'Pick..'}
              </button>
            )}
          </div>
        </div>

        {isDrawerOpen && (
          <div className='drawerContainerPromoAlert' ref={drawerContainerRef}>
            <SwipeableDrawer
              anchor='bottom'
              open={isDrawerOpen}
              onClose={() => {
                '';
              }}
              onOpen={() => {
                setIsDrawerOpen(true);
              }}
              swipeAreaWidth={56}
              disableSwipeToOpen={false}
              ModalProps={{
                keepMounted: true,
              }}
              style={{ zIndex: 10005 }}
              container={drawerContainerRef.current}
            >
              <div style={{ height: '80vh' }}>
                <div style={{ marginLeft: '13px', marginTop: '10px' }}>
                  <DeliveryToggleBtns />
                </div>
                <DeliveryOptionsNewSlots />
              </div>
              <AtomicButton
                label='Update'
                style={{
                  width: '90%',
                  backgroundColor: 'black',
                  fontSize: '14px',
                  height: '35px',
                  margin: '20px',
                }}
                handleSubmit={() => {
                  OkyToDelivery();
                }}
                endIcon={''}
                startIcon={''}
              />
            </SwipeableDrawer>
          </div>
        )}
      </>
    );
  }

  return (
    <div>
      <DeliveryToggleBtns />
      <AlertDialog
        isLoading={false}
        open={isAlertOpen}
        // setOpen={setAlertOpen}
        onAgree={onAlertAgree}
        onDisagree={onAlertDisagree}
        buttonAgreeLabel={buttonAgreeLabel}
        buttonDisagreeLabel='Cancel'
        displayText=''
        showAgreeButton={showAgreeButton}
        showDisagreeButton={showDisagreeButton}
      >
        <DeliveryToggleBtns />
        <DeliveryOptionsNewSlots />
      </AlertDialog>
    </div>
  );
};

export default DeliveryTimeSlotPicker;
